import { useState } from 'react';

import { faChevronDown, faChevronUp } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ButtonBase, Card, Collapse, Stack, Typography } from '@mui/material';

import DeviceResetCardBody from './DeviceResetCardBody';
import DeviceResetCardHeader from './DeviceResetCardHeader';
import { DeviceTriggerState } from 'src/hooks/usePendingDeviceTriggers';

interface DeviceResetCardProps {
    device: DeviceTriggerState;
    isMultiDeviceAlert: boolean;
}

/** One card per device. Instructions collapse when the alert involves more than one. */
export default function DeviceResetCard({ device, isMultiDeviceAlert }: DeviceResetCardProps) {
    const [isOpen, setIsOpen] = useState(false);

    const hasInstructionToShow = isMultiDeviceAlert && device.isPending;

    return (
        <Card sx={{ p: 2 }}>
            <Stack sx={{ gap: 2 }}>
                <DeviceResetCardHeader device={device} />
                {hasInstructionToShow ? (
                    <>
                        <Collapse in={isOpen} unmountOnExit>
                            <DeviceResetCardBody device={device} />
                        </Collapse>
                        <ButtonBase
                            onClick={() => setIsOpen((open) => !open)}
                            sx={{ gap: 1, color: 'primary.main' }}
                        >
                            <Typography variant="body2">
                                {isOpen ? 'Hide Instructions' : 'View Instructions'}
                            </Typography>
                            <FontAwesomeIcon
                                icon={isOpen ? faChevronUp : faChevronDown}
                                size="sm"
                            />
                        </ButtonBase>
                    </>
                ) : (
                    !isMultiDeviceAlert && <DeviceResetCardBody device={device} />
                )}
            </Stack>
        </Card>
    );
}
